<template>
    <footer class="py-3 my-4">
        <p class="text-center text-light">Made by your's truly</p>
        <p class="text-center text-light">Made with Vue, Bootstrap and hosted on git pages</p>
    </footer>
</template>

<script>
    export default {
    name: 'basefooter',
    };
</script>